import { StyleSheet, Text } from '@react-pdf/renderer';

import { PDF_COLORS, PDF_FONT_FAMILY } from './styles';

const styles = (margin = 0) =>
  StyleSheet.create({
    title: {
      fontFamily: PDF_FONT_FAMILY,
      // Maps to Inter Light (300) — falls back to Regular when the Light
      // weight isn't bundled. Matches "Subtitle 1 Inter Light 16pt".
      fontWeight: 300,
      fontSize: 16,
      color: PDF_COLORS.textPrimary,
      paddingTop: 8,
      paddingBottom: 4,
      marginBottom: margin,
    },
  });

const ModuleTitle = ({ title, margin }: { title: string; margin?: number }) => (
  <Text style={styles(margin).title} minPresenceAhead={100}>
    {title}
  </Text>
);

export default ModuleTitle;
